module.exports = __webpack_public_path__ + "static/media/Project1_Fig19.156c786d.png";